import React, { useEffect, useState } from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import {
  AllCampaingsAtom,
  showHideTableAtom,
  NewLeadTabFilterAtom,
} from '../../../Services/_states/Machadalo/newLeads';
import { showHideModalAtom } from '../../../Services/_states';
import { useRecoilState } from 'recoil';
import { newLeadActions } from '../../../Services/_actions/Machadalo/newLead.actions';
import Button from 'react-bootstrap/Button';
import NewViewLeadsTable from './NewViewLeadsTable';
import DownloadModal from '../../common/Modals/DownloadModal';
import ReactPagination from '../../../components/Shared/Pagination';
import SelectDropdown from '../../../components/Shared/SelectDropdown';
import SearchBox from '../../../components/Shared/SearchBox';
import TableHeader from '../../../components/Shared/TableHeader';
import { dateFormate } from '../../../utils/helper';

export default function CampaignList(props) {
  const NewLeadAction = newLeadActions();
  const [CampaignList, setCampaignList] = useRecoilState(AllCampaingsAtom);
  const [showHideTable, setshowHideTable] = useRecoilState(showHideTableAtom);
  const [showHideModal, setshowHideModal] = useRecoilState(showHideModalAtom);
  const [filters, setFilters] = useRecoilState(NewLeadTabFilterAtom);
  const [paginationData, setPaginationData] = useState({
    pageNo: 1,
    totalcount: CampaignList.length,
    startIndex: 0,
    endIndex: 9,
  });
  const [campaignData, setCampaignData] = useState({});

  const [headerData, setheaderData] = useState([
    {
      name: 'S.No.',
      key: 'index',
    },
    {
      name: 'Campaign Name',
      key: 'campaign_name',
    },

    {
      name: 'Start Date',
      key: 'start_date',
      sortIcon: {
        show: true,
        direction: (
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-sort-down"
              viewBox="0 0 16 16"
            >
              <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z" />
            </svg>
          </span>
        ),
      },
    },
    {
      name: 'Supplier Count',
      key: 'supplier_count',
      sortIcon: {
        show: true,
        direction: (
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-sort-down"
              viewBox="0 0 16 16"
            >
              <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z" />
            </svg>
          </span>
        ),
      },
    },
    {
      name: 'View Leads',
      key: 'View Leads',
    },
    {
      name: 'Action',
      key: 'Action',
    },
  ]);
  const dropdownOption = [
    { label: 'All', value: 'All' },
    { label: 'Leads', value: 'Leads' },
    { label: 'Survey', value: 'Survey' },
    { label: 'Feedback', value: 'Feedback' },
    { label: 'Survey Leads', value: 'Survey Leads' },
  ];
  const supplierTypeCode = [
    { label: 'ALL', value: 'all' },
    { label: 'Residential Society', value: 'RS' },
    { label: 'Corporate Park', value: 'CP' },
    { label: 'Bus Shelter', value: 'BS' },
    { label: 'Gym', value: 'GY' },
    { label: 'Saloon', value: 'SA' },
    { label: 'Retail Store', value: 'RE' },
    { label: 'Bus', value: 'BU' },
    { label: 'Corporates', value: 'CO' },
    { label: 'Educational Institute', value: 'EI' },
    { label: 'Gantry', value: 'GN' },
    { label: 'Hospital', value: 'HL' },
    { label: 'Hording', value: 'HO' },
    { label: 'In-shop Retail', value: 'IR' },
    { label: 'Radio Channel', value: 'RC' },
    { label: 'TV Channel', value: 'TV' },
    { label: 'Mix', value: 'mix' },
  ];

  useEffect(() => {
    NewLeadAction.getAllCampaigns(filters);
  }, []);

  const handlePageChange = async (event) => {
    let value = event.selected + 1;
    if (value === 1) {
      setPaginationData({
        pageNo: 1,
        totalcount: CampaignList.length,
        startIndex: 0,
        endIndex: 9,
      });
    } else {
      setPaginationData({
        ...paginationData,
        startIndex: paginationData.endIndex + 1,
        endIndex: value * 10 - 1,
        pageNo: value,
      });
    }
  };
  const getLeadsByCampaign = async (row) => {
    let temp = { ...filters, campaign_id: row.campaign_id, next_page: 0 };
    await NewLeadAction.getLeadByCampaignId(temp);
    await NewLeadAction.getClientStatusList(row);
    setFilters({ ...filters, campaign_id: row.campaign_id });
    setshowHideTable({ ...showHideTable, viewLeads: { show: true } });
    setCampaignData(row);
  };

  const openEmailModal = async (item) => {
    let response = await NewLeadAction.getClientStatusList(item);
    setClientStatus([...response.client_status]);
    setshowHideModal({ EmailModal: true });
    setCampaignData(item);
    // setshowHideModal({ ...showHideModal, email: { show: true } });
  };

  const handleSelect = (data) => {
    let temp = { ...filters, lead_type: data.value };
    setFilters({ ...filters, lead_type: data.value });
    NewLeadAction.getAllCampaigns(temp);
  };

  const handleSupplier = (data) => {
    let temp = { ...filters, supplier_type: data.value };
    setFilters({ ...filters, supplier_type: data.value });
    NewLeadAction.getAllCampaigns(temp);
  };

  const onSearch = (e) => {
    let data = { ...filters, search: e };
    setFilters({ ...filters, search: e });
    if (e != '' && e.length > 2) {
      NewLeadAction.getAllCampaigns(data);
    }
  };

  const sortTableBy = (header) => {
    if (header.key === 'supplier_count') {
      let sortedData = [...CampaignList].sort((a, b) =>
        header?.sortIcon?.show
          ? a.supplier_count - b.supplier_count
          : b.supplier_count - a.supplier_count
      );
      setCampaignList(sortedData);
    } else if (header.key === 'start_date') {
      let sortedData = [...CampaignList].sort((a, b) => {
        return header?.sortIcon?.show
          ? new Date(b.start_date) - new Date(a.start_date)
          : new Date(a.start_date) - new Date(b.start_date);
      });
      setCampaignList(sortedData);
    }
    if (header?.sortIcon?.show != undefined) {
      let newHeader = headerData.map((item, index) => {
        if (item.key === header.key) {
          return {
            ...item,
            sortIcon: {
              show: !header?.sortIcon?.show,
              direction: header?.sortIcon?.show ? (
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-sort-up"
                    viewBox="0 0 16 16"
                  >
                    <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z" />
                  </svg>
                </span>
              ) : (
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-sort-down"
                    viewBox="0 0 16 16"
                  >
                    <path d="M3.5 2.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 1.999.007.007a.497.497 0 0 0 .7-.006l2-2a.5.5 0 0 0-.707-.708L3.5 11.293zm3.5 1a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z" />
                  </svg>
                </span>
              ),
            },
          };
        } else {
          return item;
        }
      });
      setheaderData(newHeader);
    }
  };
  return (
    <>
      <TableHeader headerValue="Campaigns" />
      <div className="mobile-block d-flex page-filters">
        <div className="campaign-list-dropdown d-flex">
          <div className="me-4">
            <SelectDropdown
              className="testing"
              optionsData={dropdownOption}
              selectedValue={filters.lead_type}
              placeholder="Lead Type"
              label="Lead Type"
              id="LeadType"
              handleSelect={handleSelect}
            />
          </div>
          <div className="me-4">
            <SelectDropdown
              optionsData={supplierTypeCode}
              selectedValue={
                supplierTypeCode.find((item) => item.value === filters.supplier_type).value
              }
              placeholder="Supplier Type"
              label="Supplier Type"
              id="supplier_type"
              handleSelect={handleSupplier}
            />
          </div>
        </div>
        <SearchBox onSearch={onSearch} value={filters?.search} />
      </div>
      <Table striped bordered hover className="leads-table  mobile-t-padding">
        <Thead className="leads-tbody">
          <Tr>
            {headerData?.map((item, index) => {
              return (
                <Th
                  key={index}
                  onClick={(e) => {
                    sortTableBy(item);
                  }}
                >
                  {item.name} <span>{item?.sortIcon?.direction}</span>
                </Th>
              );
            })}
          </Tr>
        </Thead>
        <Tbody>
          {CampaignList.map((item, index) => {
            if (paginationData.startIndex <= index && paginationData.endIndex >= index) {
              return (
                <Tr key={index}>
                  <Td>{index + 1}</Td>
                  <Td>{item.name}</Td>
                  <Td>{dateFormate(item.start_date, 'DD-MM-YYYY')}</Td>
                  <Td>
                    {item.supplier_count}({item.unique_count})
                  </Td>
                  <Td>
                    <Button
                      variant="outline-dark"
                      className="lead-btn"
                      onClick={() => getLeadsByCampaign(item)}
                    >
                      View Leads
                    </Button>
                  </Td>
                  <Td>
                    <div className="action-icon">
                      <span
                        className="action-icon-item"
                        onClick={(e) => {
                          setshowHideModal({
                            ...showHideModal,
                            email: { show: true, tableName: 'Campaign', data: item },
                          });
                          NewLeadAction.getClientStatusList(item);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-envelope-at-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2zm-2 9.8V4.698l5.803 3.546zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 9.671V4.697l-5.803 3.546.338.208A4.5 4.5 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671" />
                          <path d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791" />
                        </svg>
                      </span>
                      <span
                        className="action-icon-item"
                        onClick={(e) => {
                          setshowHideModal({
                            ...showHideModal,
                            download: { show: true, tableName: 'Campaign', data: item },
                          });
                        }}
                        // onClick={(e)=>{NewLeadAction.downloadLeadsSummary(item.campaign_id)}}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-arrow-down-circle-fill"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z" />
                        </svg>
                      </span>
                    </div>
                  </Td>
                </Tr>
              );
            }
          })}
        </Tbody>
      </Table>
      <ReactPagination
        pageNo={paginationData.pageNo}
        pageSize={10}
        totalItems={CampaignList.length}
        onPageChange={handlePageChange}
      />
      <DownloadModal />

      {showHideTable.viewLeads.show && <NewViewLeadsTable Data={campaignData} />}
    </>
  );
}
